module.exports = __webpack_public_path__ + "static/img/1.96683aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/1.png
// module id = f9Fm
// module chunks = 0